import { render } from "./HasOneField.vue?vue&type=template&id=85d3d414"
import script from "./HasOneField.vue?vue&type=script&lang=js"
export * from "./HasOneField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\php-projects\\vemto apps\\tasky\\tasky_api_nova2_v9\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HasOneField.vue"]])

export default __exports__